<template>
  <v-btn v-if="!users.active.userName" flat icon large title="login" @click="login">
    <v-icon>vpn_key</v-icon>
  </v-btn>
  <v-btn v-else="" flat icon large title="logout" @click="logout">
    <v-icon>phonelink_lock</v-icon>
  </v-btn>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'log-in-out',
    computed: {
      ...mapGetters(['users']),
    },
    methods: {
      ...mapActions(['showLoginDialog']),
      logout() {
          ga('send', {
              hitType: 'event',
              eventCategory: 'logout',
              eventAction: 'login',
              eventLabel: 'logoutBtn',
              eventValue: 10
          });
        this.$auth.destroyToken();
        location.reload();
      },
      login() {
        this.showLoginDialog()
          ga('send', {
              hitType: 'event',
              eventCategory: 'login_attempt',
              eventAction: 'login',
              eventLabel: 'loginBtn',
              eventValue: 50
          });
      }
    }
  };
</script>
